const dataProvider = require('app/www/dataProviders/client/program');
const {PROGRAM_SCHEDULE_GET, PROGRAM_SCHEDULE_UPDATE} = require('app/www/constants/reducerProgram');
const {userSettingsFallback} = require('app/www/actions/userSettingsFallback');
const {asyncActionError} = require('app/www/actions/asyncActionError');

function getSchedule(params) {
    return dispatch => {
        return dataProvider.getSchedule(params)
            .then(response => {
                dispatch({
                    type: PROGRAM_SCHEDULE_GET,
                    channelId: params.channelId,
                    payload: response,
                });

                dispatch(
                    userSettingsFallback(response)
                );

                return response.reminders;
            })
            .catch(error => {
                dispatch(
                    asyncActionError(error)
                );
            });
    };
}

function updateSchedule(params) {
    return dispatch => {
        return dataProvider.getSchedule(params)
            .then(response => {
                dispatch({
                    type: PROGRAM_SCHEDULE_UPDATE,
                    payload: response,
                });

                dispatch(
                    userSettingsFallback(response)
                );
            })
            .catch(error => {
                dispatch(
                    asyncActionError(error)
                );
            });
    };
}

module.exports = {
    getSchedule,
    updateSchedule,
};
